export function isNumber(n: any): n is number {
  if (n === null) return false;
  return !Number.isNaN(Number(n)) && Number.isFinite(Number(n));
}
